export const MERCURY = 'Mercury';
export const WATSONS = 'Watsons';
export const SOUTH_STAR_DRUG = 'South Star Drug';
